import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PoliticaDePrivacidade } from 'src/app/core/politica-de-privacidade/model/politica-de-privacidade.model';

import { PoliticaDePrivacidadeModalComponent } from 'src/app/core/politica-de-privacidade/politica-de-privacidade-modal/politica-de-privacidade-modal.component';
import { PoliticaDePrivacidadeService } from 'src/app/core/politica-de-privacidade/politica-de-privacidade.service';


@Component({
  selector: 'app-politica-de-privacidade',
  templateUrl: './politica-de-privacidade.component.html',
  styleUrls: ['./politica-de-privacidade.component.css']
})
export class PoliticaDePrivacidadeComponent implements AfterViewInit {
  
  politica: PoliticaDePrivacidade = null;

  constructor(
    private politicaDePrivacidadeService: PoliticaDePrivacidadeService
  ) { }

  ngAfterViewInit(): void {
    this.buscarPoliticaAtiva();
  }
  
  buscarPoliticaAtiva(): void {
    this.politicaDePrivacidadeService
        .buscarPoliticaAtiva()
        .subscribe((politica: PoliticaDePrivacidade) => {
          this.politica = politica
        });
  }



}
